import React, { FC } from 'react';


interface FieldLabelProps {
    for?: string,

    [ additionalProps: string ]: any
}

const defaultProps: FieldLabelProps = {
    for: null
};

const FieldLabel: FC<FieldLabelProps> = ( _props ) => {

    const { for: htmlFor, children, ...props } = _props;

    return (
        <label htmlFor={ htmlFor } { ...props }>{ children }</label>
    );
};

FieldLabel.defaultProps = defaultProps;

export { FieldLabel };
